// #1743 — the task types constrained to one scheduled_tasks row per user.
//
// ⚠️ KEEP IN SYNC with src/lib/singleRowTask.ts. A Deno function module cannot
// be imported into the Vite bundle, so this list exists twice on purpose — the
// same deliberate port as scheduleNextRun.ts. A type covered by the partial
// unique index but missing from one of these lists is a writer that will
// surface a raw 23505 to a user who just added a birthday.
//
// The index lives in 20260928140000_scheduled_tasks_single_row_types.sql and
// covers exactly these values. reminder_nudge is deliberately NOT here: it is
// multi-row by design.

export const SINGLE_ROW_TASK_TYPES = ["birthday_reminder", "friend_checkin"] as const;

export type SingleRowTaskType = (typeof SINGLE_ROW_TASK_TYPES)[number];

/**
 * Postgres unique-violation.
 *
 * Read structurally: supabase-js RESOLVES { data, error } on a constraint
 * failure rather than rejecting, so a surrounding try/catch never fires.
 */
export function isUniqueViolation(error: unknown): boolean {
  return (error as { code?: string } | null)?.code === "23505";
}

/** How many times to re-read and retry before giving up. */
export const SINGLE_ROW_RETRY_LIMIT = 2;
